(function() {
	'use strict';

	angular
		.module('assetCommon')
		.directive('fileSelect', fileSelect);

	function fileSelect($parse, $rootScope, assetCommonConfig) {
		return {
			restrict: 'E',
			transclude: true,
			template: '<div class="file-input-wrapper"><input type="file" name="file" /><div ng-transclude></div></div>',
			link: function (scope, elem, attrs) {

				elem.find('input').attr('multiple', attrs.multiple);

				// reading selectAction this way, because when we declare the `scope` property on this directive,
				// the new isolate scope blows away the scope of any directly attached controllers
				var callback = attrs.selectAction && $parse(attrs.selectAction);

				elem.on('change', 'input[type="file"]', function () {
					var files = this.files;

					if (!callback) {
						// if no callback is specified, broadcast the selected files
						$rootScope.$broadcast(assetCommonConfig.filesSelectedEventName, { files: files });
					}
					else {
						scope.$apply(function () {
							callback(scope, { files: files });
						});
					}
				});
			}
		};
	}
	fileSelect.$inject = ['$parse', '$rootScope', 'assetCommonConfig'];
})();